<div class="popover-options">
  @for (group of options; track $index) {
    @for (option of group; track $index) {
      <div class="popover-option" [class.last-in-group]="$index === group.length - 1" (click)="selectOption(option)" (keyup.enter)="selectOption(option)" (keyup.space)="selectOption(option)" tabindex="0" role="button" [aria-label]="option.label">
        @if (option.icon) {
          <span class="icon" style="mask-image: url('/assets/icons/{{ option.icon }}.svg'); -webkit-mask-image: url('/assets/icons/{{ option.icon }}.svg')"></span>
        }
        <span class="label {{ option.styleClass ?? '' }}">{{ option.label }}</span>
      </div>
    }
  }
</div>